import classNames from '@/lib/classNames';

export default function Grid({ className, children }: { className?: string; children: React.ReactNode }) {
    return <div className={classNames('grid grid-cols-6 xl:grid-cols-12 gap-5', className)}>{children}</div>;
}
